import React from "react";
import { MessageCircle } from "lucide-react";

const WhatsAppWidget = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "393331341439";
    const message = "Ciao! Vorrei informazioni sui vostri servizi business.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 z-50"
      aria-label="Contattaci su WhatsApp"
    >
      <MessageCircle size={24} />
    </button>
  );
};

export default WhatsAppWidget;